import React from "react";
import { Flex } from "../Flex";
import Icon from "../Icon";
import Tooltip from "../Tooltip";

const defaultMaxRating = 5;

type Props = {
    maxRating?: number;
    userRating: number;
};

export default function Stars({ maxRating = defaultMaxRating, userRating }: Props) {
    const totalRating = maxRating;
    const userRatingStars = Array.from(Array(userRating)).map((_, i) => (
        <Icon.StarRate.XSmall.N10.Fill key={`user-rating-${i}`} />
    ));

    const defaultRatingStars = Array.from(Array(totalRating - userRating)).map(
        (_, i) => <Icon.StarRate.XSmall.N70.Fill key={`total-${i}`} />,
    );

    return (
        <Tooltip label={`${userRating} out of ${totalRating}`}>
            <Flex.Row>
                {userRatingStars
                    .concat(defaultRatingStars)
                    .map((starBlock) => starBlock)}
            </Flex.Row>
        </Tooltip>
    );
}
